import { NextFunction, Request, Response } from 'express';
import Container from 'typedi';
import { LabourService } from '../services/labour.service';
import { jsonStatus, status } from 'utils/helpers/api.responses';
import skillstastu from '../constant/status.json'
import { pick, removenull } from 'utils/helpers/utilities.services';


export class LabourController {
    public labourService = Container.get(LabourService);

    public updateLabourProfile = async (req: Request, res: Response, next: NextFunction) => {
        const t = req.t;
        const id = req.params.id;
        const data = pick(req.body, [
            'firstName',
            'lastName',
            'phone',
            'profileImage',
            'gender',
            'date_of_birth',
            'notificationPreferences',
            'occupation',
            'experienceSummary',
            'tickets',
            'certificates',
            'identification',
            'skills',
            'sitesInductedOn',
            'draft',
            'countryCode',
            'step',
            'deletedFiles'
        ]);
        removenull(data);
        const currentUser = req.user._id

        try {
            const updated = await this.labourService.updateLabourProfile(id, currentUser, data, t);

            return res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.update_success', { field: t('Labour.labour') }),
                data: updated,
            })

        } catch (error) {
            next(error)
        }
    }

    public getAll = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const t = req.t;
            const {
                page = 1,
                limit = 10,
                availability_status,
                skills,
                search,
                sortBy = 'createdAt',
                sortOrder = 'desc',
                occupation, tickets
            } = req.query;
            let parsedSkills: string[] = [];
            let parsedTickets: string[] = [];
            if (Array.isArray(skills)) {
                parsedSkills = skills.map(s => typeof s === 'string' ? s.trim() : '');
            } else if (typeof skills === 'string') {
                parsedSkills = skills.split(',').map(s => s.trim());
            }


            if (Array.isArray(tickets)) {
                parsedTickets = tickets.map(t => typeof t === 'string' ? t.trim() : '');
            } else if (typeof tickets === 'string') {
                parsedTickets = tickets.split(',').map(t => t.trim());
            }




            const result = await this.labourService.getAllLabour({
                t,
                page: Number(page),
                limit: Number(limit),
                skills: parsedSkills,
                occupation: typeof occupation === 'string' ? occupation : undefined,
                tickets: parsedTickets,
                availability_status: availability_status as string,
                search: search as string | undefined,
                sortBy: sortBy as string,
                sortOrder: sortOrder as 'asc' | 'desc',
            });

            res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.get_success', { field: t('Labour.labour') }),
                data: result.data,
                total: result.totalDocs,
                page: result.page,
                totalPage: result.totalPages,

            });
        } catch (error) {
            next(error);
        }
    };






    public getLabourById = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const t = req.t;
            const { id } = req.params;

            if (!id) {
                return res.status(status.BadRequest).json({
                    status: jsonStatus.BadRequest,
                    message: t("General.error")
                })
            }
            const labour = await this.labourService.getById(id, t);

            res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.get_success', { field: t('Labour.labour') }),
                data: labour,
            });
        } catch (error) {
            next(error);
        }
    };
    public labourDashboard = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const t = req.t
            const userId = req.user._id
            // const userId = req.params.userId
            const result = await this.labourService.labourDashboard(userId, t)
            return res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.get_success', { field: t('Labour.labourDashboard') }),
                result
            })

        } catch (error) {
            next(error)
        }
    }
    public adminDashboard = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const t = req.t
            const userId = req.user._id
            // const userId = req.params.userId
            const result = await this.labourService.adminDashboard(userId, t)
            return res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.get_success', { field: t('Labour.adminDashboard') }),
                result
            })

        } catch (error) {
            next(error)
        }
    }

    // public updateVerificationStatus = async (req: Request, res: Response, next: NextFunction) => {
    //     const t = req.t;
    //     const id = req.params.id;
    //     const { verification_status, remarks, rejectionReason } = req.body;
    //     const verifierUserId = req.user._id;

    //     try {
    //         const normalizedStatus = verification_status?.toLowerCase();

    //         const updatedLabour = await this.labourService.changeVerificationStatus(
    //             id,
    //             normalizedStatus as VerificationStatus,
    //             verifierUserId,
    //             remarks || null,
    //             rejectionReason || null,
    //             t
    //         );

    //         return res.status(status.OK).json({
    //             status: jsonStatus.OK,
    //             message: t('Labour.verification'),
    //             data: updatedLabour,
    //         });
    //     } catch (error) {
    //         next(error);
    //     }

    // };


    // public updateAvailabilityStatus = async (req: Request, res: Response, next: NextFunction) => {
    //     try {
    //         const t = req.t
    //         const { id } = req.params;
    //         const { availability_status } = req.body;


    //         const updatedLabour = await this.labourService.updateAvailabilityStatus(id, availability_status, t)

    //         res.status(status.OK).json({
    //             status: jsonStatus.OK,
    //             message: t('General.update_success', { field: t('General.status') }),
    //             data: updatedLabour
    //         });
    //     } catch (error) {
    //         next(error);
    //     }
    // }

    public getAllSkills = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const skills = Object.values(skillstastu.Skills);
            res.status(200).json({
                status: 'OK',
                data: skills
            });
        } catch (error) {
            next(error);
        }
    };

    public getOccupation = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const skills = Object.values(skillstastu.Occupation);
            res.status(200).json({
                status: 'OK',
                data: skills
            });
        } catch (error) {
            next(error);
        }
    };
    public getTickets = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const skills = Object.values(skillstastu.tickets);
            res.status(200).json({
                status: 'OK',
                data: skills
            });
        } catch (error) {
            next(error);
        }
    };




}
